/* componentes para manejar los colores
 hex a rgba y rgba a hex
*/

export const hexToRGBA = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return { r: 0, g: 0, b: 0, a: 1 };

  return {
    r: parseFloat((parseInt(result[1], 16) / 255).toFixed(4)),
    g: parseFloat((parseInt(result[2], 16) / 255).toFixed(4)),
    b: parseFloat((parseInt(result[3], 16) / 255).toFixed(4)),
    a: 1
  };
};

export const rgbaToHex = (rgbaObj) => {
  if (!rgbaObj || typeof rgbaObj !== 'object') return '#5656ff';

  const { r, g, b } = rgbaObj;
  const red = Math.round((r || 0) * 255);
  const green = Math.round((g || 0) * 255);
  const blue = Math.round((b || 0) * 255);

  return '#' + [red, green, blue]
    .map(x => x.toString(16).padStart(2, '0'))
    .join('');
};

// json a objeto color
export const parseColorJSON = (colorStr) => {
  try {
    return JSON.parse(colorStr);
  } catch {
    return { r: 0.337, g: 0.337, b: 1, a: 1 }; // 5656ff por defecto
  }
};

// objeto rgba o json a rbga() para mostrar en el front
export const rgbaObjToString = (colorInput) => {
  if (!colorInput) return 'rgba(86, 86, 255, 1)';

  try {
    const colorData = typeof colorInput === 'string'
      ? parseColorJSON(colorInput)
      : colorInput;

    const { r, g, b, a = 1 } = colorData;

    const red = Math.round(r * 255);
    const green = Math.round(g * 255);
    const blue = Math.round(b * 255);

    return `rgba(${red}, ${green}, ${blue}, ${a})`;
  } catch {
    return 'rgba(86, 86, 255, 1)';
  }
};